module.exports = __webpack_public_path__ + "static/media/flag management attendance.1650c86f.svg";